import Seo from "../components/Seo";

const COOKIES = [
  { name: "access_token", purpose: "Keeps you signed in after you log in.", duration: "60 minutes" },
  { name: "refresh_token", purpose: "Renews your signed-in session without asking for your password again.", duration: "7 days" },
];

export default function Cookies() {
  return (
    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20" data-testid="cookies-page">
      <Seo
        title="Cookie Policy | HiredToday"
        description="HiredToday only uses strictly necessary sign-in cookies. No tracking, no advertising cookies."
        path="/cookies"
      />
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-3">Legal</p>
      <h1 className="font-display text-4xl sm:text-5xl tracking-tighter font-black text-zinc-950">Cookie policy</h1>
      <p className="mt-3 text-sm text-zinc-500">Last updated: August 2026</p>

      <p className="mt-6 text-base text-zinc-600 leading-relaxed">
        Here's the honest version: HiredToday uses two cookies, and both exist only to keep you signed in. We don't use advertising cookies, analytics trackers, social media pixels or anything that follows you around the internet.
      </p>

      <section className="mt-10" data-testid="cookies-table-section">
        <h2 className="font-display text-xl font-bold text-zinc-950 mb-3">Strictly necessary cookies</h2>
        <p className="text-sm text-zinc-600 leading-relaxed mb-5">
          These are essential for the site to work. Without them you'd be logged out on every page. Under UK privacy law (PECR), strictly necessary cookies don't require consent, but we think you should know about them anyway.
        </p>
        <div className="border border-zinc-200 rounded-md overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-zinc-200 bg-zinc-50 text-left">
                <th className="px-4 py-3 font-semibold text-zinc-600">Cookie</th>
                <th className="px-4 py-3 font-semibold text-zinc-600">What it does</th>
                <th className="px-4 py-3 font-semibold text-zinc-600">Lasts</th>
              </tr>
            </thead>
            <tbody>
              {COOKIES.map((c) => (
                <tr key={c.name} className="border-b border-zinc-100 last:border-0">
                  <td className="px-4 py-3 font-mono text-xs text-zinc-900">{c.name}</td>
                  <td className="px-4 py-3 text-zinc-600">{c.purpose}</td>
                  <td className="px-4 py-3 text-zinc-600">{c.duration}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="text-sm text-zinc-600 leading-relaxed mt-4">
          We also store a small sign-in token in your browser's local storage (called <span className="font-mono text-xs">ht_token</span>). It does the same job as the cookies and is removed when you log out.
        </p>
      </section>

      <section className="mt-10" data-testid="cookies-control-section">
        <h2 className="font-display text-xl font-bold text-zinc-950 mb-3">Controlling cookies</h2>
        <p className="text-sm text-zinc-600 leading-relaxed">
          You can block or delete cookies in your browser settings at any time. Because ours are only sign-in cookies, blocking them simply means you'll need to log in again more often. The rest of the site carries on working.
        </p>
        <p className="text-sm text-zinc-600 leading-relaxed mt-3">
          If we ever add anything beyond strictly necessary cookies, we'll ask for your consent first and update this page before any of it switches on.
        </p>
      </section>
    </main>
  );
}
